/**
 * Texts for Library page
 */
export const libraryPageText = {
    title: 'CamAPS Liberty - CamAPS FX',
    titleMeta: 'CamAPS Liberty - CamAPS FX',
    descriptionMeta: 'Zugriff auf Ressourcen und Support-Materialien für CamAPS FX und CamAPS Liberty®.',
    keywords: 'camaps bibliothek, camaps fx, camaps liberty, support ressourcen, diabetes management',
    localeMeta: 'de_de',

    bannerTitle: 'Unterstützung über die Zahlen hinaus',
    bannerSubtitle: 'mit CamAPS Liberty<sup>®</sup>',
    bannerDescription: 'Wenn aktiviert, müssen Benutzer keine Kohlenhydrate zählen und keinen Pre-Mahlzeit-Insulinbolus abgeben.',
    bannerCompatibility: 'Kompatibel mit Android und iOS',
    
    announcementText: 'Jetzt verfügbar in myLoop',
    announcementDisclaimer: '',

    introTitle: 'Die erste vollständig geschlossene Loop-Funktion. Wenn Sie sie brauchen.',
    introDescription: 'Wenn aktiviert, müssen Benutzer keine Kohlenhydrate zählen und keinen Pre-Mahlzeit-Insulinbolus abgeben.',
    introSubtext: 'Verfügbar für Android- und Apple-Betriebssysteme',

    howItWorksTitle: 'Wie funktioniert es?',
    howItWorksDescription: 'Angetrieben von einer proaktiveren Version des CamAPS-Algorithmus. CamAPS Liberty antizipiert und reagiert auf Glukoseänderungen und behält dabei etablierte Sicherheitsgrenzen bei.',
    
    step1Title: 'SCHRITT 1',
    step1Description: 'Gehen Sie von Ihrem Startbildschirm zum Einstellungsmenü.',
    step2Title: 'SCHRITT 2',
    step2Description: 'Scrollen Sie nach unten und tippen Sie auf den Schalter, um zu aktivieren.',
    step3Title: 'SCHRITT 3',
    step3Description: 'Bei der ersten Nutzung müssen Sie unser Erklärvideo zu CamAPS Liberty ansehen.',
    step4Title: 'SCHRITT 4',
    step4Description: 'Bestätigen Sie, dass Sie nicht unter 13 Jahre alt oder schwanger sind.',
    step5Title: 'SCHRITT 5',
    step5Description: 'Tippen Sie erneut auf den Schalter, um zu aktivieren.',
    step6Title: 'SCHRITT 6',
    step6Description: "Alles bereit. Der CamAPS Liberty-Tab erscheint auf Ihrem Startbildschirm<sup>†</sup>.",
    step6Footnote: "<sup>†</sup> Funktioniert nur, wenn der \"Auto mode\" aktiviert ist",

    eligibilityTitle: 'Wer kann CamAPS Liberty verwenden?',
    eligibilityCriterion1: 'Bestehende Benutzer mit Typ-1-Diabetes',
    eligibilityCriterion2: '13 Jahre und älter',
    eligibilityCriterion3: 'Schwanger',
    parentsCarersTitle: 'Was ist mit Eltern und Betreuungspersonen?',
    parentsCarersBlockTitle: 'Funktion „Kindersicherung":',
    parentsCarersBlockDescription: 'Zur Vermeidung versehentlicher Nutzung',
    parentsCarersRemoteTitle: 'Fernüberwachung:',
    parentsCarersRemoteDescription: 'Companion, Glooko® und CamAPS 2-Wochen-PDF-Berichte',
    
    imageOverlayText: 'Entwickelt, um neben Ihrem aktuellen Diabetes-Managementplan zu arbeiten; nicht, um ihn zu ersetzen.',
    
    usingTitle: 'Verwendung von CamAPS Liberty',
    
    treatmentPlanText: 'CamAPS Liberty wurde entwickelt, um die Notwendigkeit routinemäßiger Mahlzeitenboli zu beseitigen. Es ersetzt nicht die anderen Bestandteile des Diabetesbehandlungsplans des Benutzers, einschließlich der regelmäßigen Überprüfung mit dem Diabetesteam.',
    
    usingLibertyTitle: 'CamAPS Liberty ansehen und kennenlernen',
    usingLibertyDescription: 'Entdecken Sie Videos, um mehr über CamAPS Liberty zu erfahren und den Einstieg zu finden.',
    // latestVideoLabel removed
    moreVideosLabel: 'Weitere Videos',
    factsheetDownloadText: 'CamAPS Liberty Factsheet (pdf)',
    factsheetUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/camaps_liberty_faqs_de.pdf',
    usingLibertyFeaturedVideo: {
        youtubeUrl: 'https://youtu.be/px9QSOhy544',
        title: 'CamAPS Liberty: Erste Schritte',
        description: 'Candice Ward erklärt, wie Sie CamAPS Liberty einrichten und nutzen.',
        duration: '31:50',
        date: '15 Sep 2026',
    },
    usingLibertyMoreVideos: [
        {
            youtubeUrl: 'https://youtu.be/QAYy8dTXUUc',
            title: 'Praktische Tipps: CamAPS Liberty',
            duration: '01:49',
        },
        {
            youtubeUrl: 'https://youtu.be/K7_j-Sk5Fas',
            title: 'Einführung in CamAPS Liberty',
            duration: '14:42',
        },
        {
            youtubeUrl: 'https://youtu.be/0dp5A8z_SEk',
            title: 'Dieses Fully-Closed-Loop-Gefühl',
            duration: '04:22',
        },
        {
            youtubeUrl: 'https://youtu.be/1U9CTzelTSw',
            title: 'Die CamAPS Liberty-Funktion',
            duration: '03:50',
        }
    ],
    
    whatHappensNextTitle: 'Was passiert als Nächstes?',
    whatHappensNextText: 'Wir werden in den kommenden Monaten einen Pilotversuch in einem einzigen Markt durchführen. Bleiben Sie dran für weitere Details.',
};

